import { render } from "./ThemeEditDiagramModal.vue?vue&type=template&id=3fff2baa"
import script from "./ThemeEditDiagramModal.vue?vue&type=script&lang=js"
export * from "./ThemeEditDiagramModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__